import { api } from "../base";

const staticPricesEndpoints = api.injectEndpoints({
  endpoints: (build) => ({
    /** Fetches active static price override schedules. */
    getStaticPriceOverrides: build.query<unknown[], void>({
      query: () => ({ url: "/api/static_override/v1/active" }),
      providesTags: ["StaticPriceOverrides"],
    }),

    /** Uploads static price override schedules. */
    uploadStaticPriceOverrides: build.mutation<void, unknown[]>({
      query: (payload) => ({
        url: "/api/static_override/v1/upload",
        method: "POST",
        body: payload,
      }),
      invalidatesTags: ["StaticPriceOverrides"],
    }),

    /** Deactivates a static price override for a symbol. */
    deactivateStaticPriceOverride: build.mutation<void, string>({
      query: (symbol) => ({
        url: "/api/static_override/v1/deactivate",
        params: { symbol },
        method: "DELETE",
      }),
      invalidatesTags: ["StaticPriceOverrides"],
    }),
  }),
});

export const {
  useGetStaticPriceOverridesQuery,
  useUploadStaticPriceOverridesMutation,
  useDeactivateStaticPriceOverrideMutation,
} = staticPricesEndpoints;
